import styles from '@components/Slider/Slider.styles';
import { fillArrayWithNumbers } from '@utils/misc';
type PropsType = {
  slidesLength: number;
  current: number;
  onClick: (index: number) => void;
};
const SliderIndicator = ({
  slidesLength,
  current,
  onClick
}: PropsType) => <div sx={styles.sliderIndicatorsWrapper} className="slider-indicator">
    {fillArrayWithNumbers(slidesLength).map(index => <button type="button" sx={styles.sliderIndicator(index === current)} onClick={() => onClick(index)} key={index} />)}
  </div>;
SliderIndicator.displayName = 'SliderIndicator';
export default SliderIndicator;